export default __webpack_public_path__ + "static/media/arche.c329aedb.png";